// Dependencies
import React, { Component } from "react";
import axios from "axios";
import config from "../../../libs/config";
import Auth from "../../../services/authService";
import Modal from "react-responsive-modal";
import Icons from "../../../icons.svg";
import TabLang from "../TabLang";
import { UserListCard } from "../../Card";
import { toast } from "react-toastify";
import { Tooltip } from "react-tippy";

// Components & Containers
import "./style.css";
import Loader from "../../Loader";
export default class AdminTimeline extends Component {
  constructor(props) {
    super(props);

    this.auth = new Auth();
    this.headers = this.auth.buildAuthHeader();

    this.state = {
      subscribers: undefined,
      isOpen: false,
      inputType: "password",
      newPass: '',
      verifyPass: ''
    };
  }

  componentDidMount = () => {
    const { history, location } = this.props;
    if (this.auth.authGuard()) {
      this.getSubscribers();
    } else {
      history.push("/login");
    }
  };

  getSubscribers = () => {
    axios
      .get(`${config.BASE_URL}/subscribe`)
      .then(res =>
        this.setState({ subscribers: res.data.subscriber })
      )
      .catch(err => {
        let error = err.response;
        let status = err.response.status;
        if (status === 404 || status === 500) {
          toast.warn(error.msg);
        } else if (status === 401) this.auth.logout();
      });
  };

  handleSubscribers = (msg, id) => {
    let subscribers = this.state.subscribers;

    if (msg === "delete") {
      let newSubscribers = subscribers.filter(
        subscriber => subscriber._id !== id
      );

      this.setState({ subscribers: newSubscribers });
    }
  };

  onShowCloseModal = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  handleUser = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  changePassword = (e) => {
    e.preventDefault();
    const { newPass, verifyPass } = this.state
    const user = this.auth.getProfile();

    if (newPass !== verifyPass) return toast.warn("Passwords do not match");

    if (newPass === '' || newPass === ' ' || verifyPass === '' || verifyPass === ' ') return toast.warn(`Inputs can't be empty`);

    if (newPass.length <= 5 || newPass.length <= 5) return toast.warn(`Passwords may have more than 5 chars`);

    axios
      .post(`${config.BASE_URL}/user/${user._id}`, { password: newPass }, this.headers)
      .then(res => {
        let data = res.data;

        this.setState({ isOpen: false, newPass: '', verifyPass: '' }, () => {
          toast(data.msg);
        })
      })
      .catch(err => {
        let error = err.response;
        let status = err.response.status;
        if (status === 404 || status === 500) {
          toast.warn(error.msg);
        } else if (status === 401) this.auth.logout();
      });
  }

  render() {
    const { subscribers, isOpen, inputType } = this.state;
    return (
      <div>
        <div className="containerStories">
          <div className="headerAdmin">
            <h1 className="headerAdmin__storiesTitle">Users</h1>
            <Tooltip
              title="Change Own Password"
              position="right"
              size="big"
              arrow="true"
            >
              <button className="headerAdmin__addBTN" onClick={this.onShowCloseModal}>
                <svg className="headerAdmin__addBTN__ico">
                  <use xlinkHref={`${Icons}#icon-pen`} />
                </svg>
              </button>
            </Tooltip>
          </div>
          {subscribers === undefined ? (
            <Loader />
          ) : (
            subscribers.map(subscriber => {
              return (
                <UserListCard
                  key={subscriber._id}
                  subscriber={subscriber}
                  handleSubscribers={this.handleSubscribers}
                />
              );
            })
          )}
        </div>
        <Modal
          open={isOpen}
          onClose={this.onShowCloseModal}
          classNames={{ modal: "custom-modal" }}
        >
          <div className="containerModal">
            <h1 className="headerAdmin__storiesTitle">Change own Password</h1>
            <div className="form">
              <div className="col2">
                <div className="formContainer">
                  <input type="text"
                    name="newPass"
                    type={inputType}
                    onChange={this.handleUser}
                    placeholder="New Password" className="formContainer__item" />
                  <input type="text"
                    name="verifyPass"
                    type={inputType}
                    onChange={this.handleUser}
                    placeholder="Repeat new password" className="formContainer__item" />
                </div>
              </div>
            
              <button className="btnUpload" onClick={e => this.changePassword(e)}>Save</button>
                
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Users/index.jsx